import React from "react";
import { Navigate } from "react-router-dom";
import { usePermission } from "../contexts/PermissionContext";
import Spinner from "../components/spinner";

const ProtectedRoute = ({
  children,
  roles = [],
  excludeRoles = [],
  permission = "",
  permissionMode = "or",
  redirectTo = "/",
}) => {
  const { hasAccess, loading } = usePermission();
  const userRole = localStorage.getItem("user_role");

  if (permission && loading) {
    return <Spinner />;
  }

  const allowed = hasAccess({ roles, permission, mode: permissionMode });

  if (allowed && excludeRoles.includes(userRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute;
